// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PlusBadge":"bcv_a bhi_rh bhi_ri bhi_vf bhi_ec bhi_vc bhi_gq bhi_kf"};